import { FC } from 'react';

import PageSection from 'components/PageSection';
import AppDatePicker from 'components/FormElements/AppDatePicker';
import FieldRow from 'components/FormElements/FieldRow';
import FieldSwitch from 'components/FormElements/FieldSwitch';
import useEqualisations from 'hooks/lp/data/equalisations/useEqualisations';
import { useLayoutContext } from 'contexts/LayoutContext';

type Props = {
  title: string;
  viewDate: Date | null;
  onViewDateChange: (date: Date | null) => void;
  showUnapprovedOnly?: boolean;
  onShowUnapprovedOnlyChange?: (value: boolean) => void;
  disableFields?: boolean;
};

const PaymentFiltersAndSummary: FC<Props> = ({
  title,
  showUnapprovedOnly,
  viewDate,
  onShowUnapprovedOnlyChange,
  onViewDateChange,
  disableFields = false,
}) => {
  const { selectedVehicleId } = useLayoutContext();
  const { latestApprovedEqualisationDate } = useEqualisations(
    selectedVehicleId ?? '',
  );

  return (
    <PageSection title={title} withSpacing>
      {onShowUnapprovedOnlyChange && showUnapprovedOnly !== undefined && (
        <FieldRow title="View" centerTitle>
          <FieldSwitch
            checked={showUnapprovedOnly}
            uncheckedLabel="All transactions"
            checkedLabel="Unapproved transactions only"
            disabled={disableFields}
            onChange={(e) => {
              onShowUnapprovedOnlyChange(e.target.checked);
            }}
          />
        </FieldRow>
      )}

      <FieldRow title="Select view date" centerTitle>
        <AppDatePicker
          placeholder="Select view date"
          value={viewDate}
          disabled={disableFields}
          onChange={(date) => {
            onViewDateChange(date);
          }}
          disableFuture
          minDate={latestApprovedEqualisationDate}
        />
      </FieldRow>
    </PageSection>
  );
};

export default PaymentFiltersAndSummary;
